/**
 * Returns a numerical timestamp in seconds: 512969520
 * @hidden
 */
export const getSecondsTimestamp = ({ date }) => {
    return Math.floor(date.getTime() / 1000);
};
/**
 * Returns a numerical timestamp in milliseconds: 512969520900
 * @hidden
 */
export const getMillisecondsTimestamp = ({ date }) => {
    return date.getTime();
};
//# sourceMappingURL=timestamp.js.map